import { FC, useRef } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { useLayout } from "../../core";
import { KTSVG, toAbsoluteUrl } from "../../../helpers";
import { AsideMenu } from "./AsideMenu";
import { Topbar } from "../header/Topbar";

const AsideDefault: FC = () => {
    const { config, classes } = useLayout();
    const asideRef = useRef<HTMLDivElement | null>(null);
    const { aside } = config;

    return (
        <div
            id="kt_aside"
            className={clsx("aside", classes.aside.join(" "))}
            data-kt-drawer="true"
            data-kt-drawer-name="aside"
            data-kt-drawer-activate="{default: true, lg: false}"
            data-kt-drawer-overlay="true"
            data-kt-drawer-width="{default:'200px', '300px': '250px'}"
            data-kt-drawer-direction="start"
            data-kt-drawer-toggle="#kt_aside_mobile_toggle"
            ref={asideRef}
        >
            {/* begin::Brand */}
            <div className="aside-logo flex-column-auto">
                <div className="d-flex w-100">
                    <Topbar aside={aside} />
                </div>

                {/* begin::Aside toggler */}

                {/* end::Aside toggler */}
            </div>
            {/* end::Brand */}

            {/* begin::Aside menu */}
            <div className="aside-menu flex-column-fluid">
                <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
            </div>
            {/* end::Aside menu */}
        </div>
    );
};

export { AsideDefault };
